import React, { useState, useEffect } from 'react';

import './styles.css';

import billServices from '../../../services/admFin/billServices';
import productServices from '../../../services/admFin/productServices';
import compare from '../../../functions/compare';
import loadTextTest from '../../../functions/loadTextTest';

import MainView from '../../../components/MainView';
import UserPhoto from '../../../components/UserPhoto';
import BillsCard from '../Bills/BillsCard';
import PopupBill from '../Bills/PopupBill';
import PopupNewBill from '../Bills/PopupNewBill';
import ProductsCard from '../Stock/ProductsCard'
import { accessTypes, getAdmFinAccess } from '../../../services/accessServices';

export default function AdmFinHome(props) {
    const accessInfos = JSON.parse(localStorage.getItem("_accessInfos"));
    const [products, setProducts] = useState(null);
    const accesses = getAdmFinAccess();
    const [hasAccessBills, setHasAccessBills] = useState(false);
    const [hasAccessProducts, setHasAccessProducts] = useState(false);

    useEffect(() => {
            setHasAccessBills(accesses.some(access => access.tipo.includes(accessTypes[0][1]) || access.tipo.includes(accessTypes[1][1])));
            setHasAccessProducts(accesses.some(access => access.tipo.includes(accessTypes[0][1]) || access.tipo.includes(accessTypes[4][1])));
    }, []);

    useEffect(() => {
        if(hasAccessProducts)
            readProducts();
    }, [hasAccessProducts])

    async function readProducts() {
        const response = await productServices.getProducts();
        if (response.status === 200) {
            setProducts(response.data.sort((a, b) => compare(a.quantidade_critica - a.quantidade, b.quantidade_critica - b.quantidade)));
        } else
            alert("Erro ao ler produtos, tente novamente!");
    }

    function updateProduct(product) {
        let index = products.findIndex(item => item.id === product.id);
        if (index !== -1) {
            let auxArray = products.slice();
            auxArray[index] = product;
            setProducts(auxArray);
        }
    }

    return (
        <MainView currentPage='home' admFinMenu >
            <div className='admfin-home-page-message'>
                <h2>Bem vindo ao</h2>
                <h1>PORTAL <b>Boston</b>City</h1>
            </div>

            <hr />

            <div className='admfin-home-page-user'>
                <div className='admfin-home-page-user-infos'>
                    <UserPhoto src={accessInfos.foto} />
                    <div className='admfin-home-page-user-infos-texts'>
                        <h3>{loadTextTest(accessInfos.nome)}</h3>
                        <p>Adm/Fin</p>
                    </div>
                </div>
            </div>

            {
                hasAccessBills ?
                <div className='admfin-home-page-cards'>
                    <div className='admfin-home-page-cards-group'>
                        <BillsCard
                            toPay
                            lateList
                        />

                        <BillsCard
                            toReceive
                            lateList
                        />
                    </div>

                    <div className='admfin-home-page-cards-group'>
                        <BillsCard
                            toPay
                            todaysList
                        />

                        <BillsCard
                            toReceive
                            todaysList
                        />

                    </div>
                </div>
                :
                null
            }
            {
                hasAccessProducts ?
                <ProductsCard
                criticalMode
                products={products}
                onUpdate={updateProduct}
                />
                :
                null
            }

        </MainView>
    )
}